import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from "@/lib/lyg/string";
import { useSelector, useDispatch } from 'react-redux';
import InfoArrFunc from "@/pages/comp/plan/todo/stu_card_list/area/card_list/func/info_arr_func";
import SearchArea from "../search";
import SearchRoomArea from "../search_room";
import RoomListArea from "../room_list";
import CardRoomListArea from "../card_room_list";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import FindStudentPopup from "../../popup/find_stu_popup";
import ViewDeskPopup from "../../popup/view_desk_popup";
import SelectStuAllowDeskPopup from "../../popup/select_stu_alloc_popup";
import ViewRoomPopup from "@/pages/comp/edu/desk/main/popup/view_room_popup";
import ViewStuLayerPopup from "@/pages/comp/basic/student/popup/view_layer";
import ViewTodoDaySortPopup from "@/pages/comp/plan/calendar/area/popup/view_todo_day_sort";
import WriteTodoPopup from "@/pages/comp/plan/todo/popup/write";
import WriteTodoDailyCByStuPopup from "@/pages/comp/plan/todo_dailyc/popup/write_by_stu";
import LoadingComponent from "@/pcomponents/common/content/loading";
import { useNavigate } from 'react-router-dom';
import DeskUseDataFunc from "@/pcomponents/common/content/edu/desk/func/desku_func";
import RoomMsgFunc from "./func/msg_func";
import DataIo from "./area/io";

function RoomListWrap(props: any) {
  let myProps = {
    s_room_seq: "",
    s_subject: "",
    is_show_search_room: true,
    is_show_paging: true,
    is_detal_popup: true,
    is_able_card_view: false,
    is_show_history_btn: true,
    select_stu_data: {},
    on_refresh_parent: () => { },
    on_alloc_student: (inData: any) => { },
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const [listOpt, setListOpt] = useState({
    now_page: 1,
    num_per_page: 20,
    order_id: 'a_order_num, a_name',
    order_type: '',
    s_room_seq: myProps.s_room_seq,
    s_is_use: "1",
    s_addon_desk: "1",
    s_addon_use: "1",
    s_addon_lecture: "1",
    s_addon_now_time: "1",
    s_select_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
  });
  const listOptRef = useRef<any>(listOpt);
  const room_list_wrap_ref = useRef<any>();
  const RoomListAreaRef = useRef();
  const [search_room_list, set_search_room_list] = useState([]);
  const [infoArr, setInfoArr] = useState([]);
  const roomInfoArrRef = useRef<any>([]);
  roomInfoArrRef.current = infoArr;
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const [student_info_arr, set_student_info_arr] = useState([]);
  const student_info_arr_ref = useRef<any>([]);
  student_info_arr_ref.current = student_info_arr;
  const pre_room_info_arr = useRef([]);
  const [now_ymdhis, set_now_ymdhis] = useState(DateFunc.get_date_format(new Date(), "Y-m-d h:i:s"));
  const [is_now_time, set_is_now_time] = useState(true);
  const now_ymdhis_ref = useRef(now_ymdhis);
  const [is_show_only_now_lecture, set_is_show_only_now_lecture] = useState(true);
  const [is_show_msg, set_is_show_msg] = useState(strFunc.get_storage("desk_main_is_show_msg", "1") == "1" ? true : false);
  const [room_msg_arr, set_room_msg_arr] = useState<any>([]);
  const [is_show_stu_select_list, set_is_show_stu_select_list] =
    useState(strFunc.get_storage("desk_main_is_show_stu_select_list", "") == "1" ? true : false);
  const [is_stu_filter_lecture, set_is_stu_filter_lecture] =
    useState(strFunc.get_storage("desk_main_is_stu_filter_lecture", "") == "1" ? true : false);
  const [is_stu_filter_use_desk, set_is_stu_filter_use_desk] =
    useState(strFunc.get_storage("desk_main_is_stu_filter_use_desk", "") == "1" ? true : false);
  const [select_stu_filter, set_select_stu_filter] = useState({
    s_stu_grade: "",
    s_user_name: "",
    s_attend_sort_detail: "no_absent",//attend,late,absent,empty,no_absent
  });
  const [select_stu_data, set_select_stu_data] = useState<any>({
    is_select: false,
    stu_info: null,
    select_subject: "",
    ...myProps.select_stu_data
  });
  const [dragged_desku_info, set_dragged_desku_info] = useState(null);
  const [is_add_attend_by_desk, set_is_add_attend_by_desk] =
    useState(strFunc.get_storage("desk_main_is_add_attend_by_desk", "1") == "1" ? true : false);
  const [is_able_card_view, set_is_able_card_view] = useState(myProps.is_able_card_view);
  const [cardview_sort, set_cardview_sort] = useState(strFunc.get_storage("desk_main_cardview_sort", "todo"));//todo,attend
  const [select_desku_seq_arr, set_select_desku_seq_arr] = useState([]);
  const data_io_ref = useRef<any>(null);
  const [loading_data, set_loading_data] = useState({
    is_display: false,
    text: "저장 되었습니다.",
  });

  //하루전꺼부터 조회
  let tmp_start_date = listOpt.s_select_date;
  let tmp_start_date_json = DateFunc.get_date_json(new Date(tmp_start_date));
  let pre_date_change_num = -1;
  if (tmp_start_date_json.day == 1) {
    //일요일이면 3일뒤로이동(금요일부터 보이게한다.)
    pre_date_change_num = -3;
  }
  let pre_date_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(tmp_start_date), 'day', pre_date_change_num), "Y-m-d");

  const [popupData, setPopupData] = useState<any>({
    stu_info: null,
    room_info: null,
    desk_info: null,
    desku_info: null,
    now_ymdhis: "",
    now_lecture_data: null,
    room_seq: "",
    select_stu_name: "",
    select_stu_seq: "",
    select_date: "",
    subject_name: "",
    todo_dailyc_sort: "",
    select_stu_seq_arr: [],
    write_page_data: {
      is_show: false,
      is_update: false,
      is_view_mode: true,
      is_view_basic: false,
      info_arr: [],
      select_idx: 0,
      default_write_info: {},
    },

    isOpen: false,
    sort: "find_stu",//find_stu,view_desk,view_room,stu_view
    title: "팝업",
    width: "800px",
    height: "100%",
    has_header: true,
  });

  useEffect(() => {
    search_room_list_by_ajax();
    get_student_arr_by_ajax({});
  }, []);

  useEffect(() => {
    const count_loop = setInterval(tick_now_ymdhis, 1000);
    return () => {
      clearInterval(count_loop);
    };
  }, [is_now_time]);

  const tick_now_ymdhis = () => {
    if (is_now_time == false) { return false; }
    let tick_date_obj = DateFunc.get_change_date(new Date(now_ymdhis_ref.current), 'sec', +1);
    now_ymdhis_ref.current = DateFunc.get_date_format(tick_date_obj, "Y-m-d h:i:s");
    set_now_ymdhis(now_ymdhis_ref.current);
    if (parseInt(DateFunc.get_date_format(tick_date_obj, "s")) == 0) {
      list({});
      get_student_arr_by_ajax({});
    }
  };

  const search_room_list_by_ajax = () => {
    let search_room_form_json = {
      order_id: 'a_order_num, a_name',
      order_type: '',
      s_is_use: "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/room/list', search_room_form_json, get_axios_data())
      .then((response) => {
        if (response.data["result"] == "true") {
          set_search_room_list(response.data["data"]["info_arr"]);
          let tmp_s_room_seq = listOpt.s_room_seq;
          if (listOpt.s_room_seq == "") {
            if (response.data["data"]["info_arr"].length > 0) {
              //tmp_s_room_seq = response.data["data"]["info_arr"][0]["a_seq"];
            }
          }
          list({ s_room_seq: tmp_s_room_seq });
        }
      });
  };

  const list = (inOptObj: any) => {
    let tmp_listOpt: any = {
      ...listOptRef.current,
      is_now_time: is_now_time,
      ...inOptObj
    };
    listOptRef.current = tmp_listOpt;
    setListOpt(listOptRef.current);
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/room/list', tmp_listOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (tmp_listOpt.is_now_time) {
            set_now_ymdhis(response.data["data"]["now_ymdhis"]);
            now_ymdhis_ref.current = response.data["data"]["now_ymdhis"];
            let change_room_msg_arr = RoomMsgFunc.get_msg_arr_by_room_list({
              room_info_arr: response.data["data"]["info_arr"],
              pre_room_info_arr: pre_room_info_arr.current,
              room_msg_arr: room_msg_arr,
              now_ymdhis: response.data["data"]["now_ymdhis"],
            });
            set_room_msg_arr(change_room_msg_arr);
            pre_room_info_arr.current = response.data["data"]["info_arr"];
            myProps.on_refresh_parent();
          }
        } else {

        }
      });
  };

  const get_student_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      s_select_date: listOpt.s_select_date,
      ...inData
    };
    let tmp_s_select_date = opt_obj.s_select_date
    let form_json_data: any = {
      order_id: "a_stu_grade, a_user_name",
      s_stu_state: "now",
      s_grade: ["student"],
      s_addon_attend: "1",
      s_addon_attend_start_date: tmp_s_select_date,
      s_addon_attend_end_date: tmp_s_select_date,
      s_addon_lecture_time: "1",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    if (is_able_card_view) {
      form_json_data = {
        ...form_json_data,
        s_addon_todo: "1",
        s_addon_todo_start_date: tmp_s_select_date,
        s_addon_todo_end_date: tmp_s_select_date,
        s_addon_todo_s_todo_sort: "",
        s_addon_todo_s_state: "",
        s_addon_todo_addon_par: "",
        s_addon_todo_addon_file: "1",
        s_addon_home_work_file: "1",
        s_addon_home_work_file_start_date: tmp_s_select_date,
        s_addon_home_work_file_end_date: tmp_s_select_date,
        s_addon_plan_study_file: "1",
        s_addon_plan_study_file_start_date: tmp_s_select_date,
        s_addon_plan_study_file_end_date: tmp_s_select_date,
        s_addon_todo_dailyc: "1",
        s_addon_todo_dailyc_start_date: tmp_s_select_date,
        s_addon_todo_dailyc_end_date: tmp_s_select_date,
      };
      form_json_data["s_addon_todo_start_date"] = pre_date_str;
      form_json_data["s_addon_home_work_file_start_date"] = pre_date_str;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/basic/user/user/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          let tmp_stu_info_arr = response.data["data"]["info_arr"];
          if (is_able_card_view) {
            tmp_stu_info_arr = InfoArrFunc.get_info_arr_by_filter({
              info_arr: response.data["data"]["info_arr"],
              list_opt: form_json_data,
              base_date_str: form_json_data["s_addon_todo_end_date"],
              pre_date_str: pre_date_str
            });
          }
          set_student_info_arr(tmp_stu_info_arr);
        } else {

        }
      });
  };

  const get_desku_arr_by_select_desku_seq_arr = (inData: any) => {
    let opt_obj = {
      now_ymdhis: now_ymdhis,
      check_row_val_arr: select_desku_seq_arr,
      ...inData
    };
    
    let select_desku_arr: any = [];
    for (let room_i = 0; room_i < infoArr.length; room_i++) {
      let room_info: any = infoArr[room_i];
      
      if (room_info.desku_arr) {
        let now_desku_arr: any = DeskUseDataFunc.get_now_desku_arr({
          now_ymdhis: opt_obj.now_ymdhis,
          desku_arr: room_info.desku_arr,
        });
        
        for (let i = 0; i < now_desku_arr.length; i++) {
          let tmp_desku_info = now_desku_arr[i];
          let tmp_desku_pri_val = tmp_desku_info["a_ymd"] + "," + tmp_desku_info["a_seq"];
          if (strFunc.str_in_array(tmp_desku_pri_val, opt_obj.check_row_val_arr) != -1) {
            select_desku_arr.push(tmp_desku_info);
          }
        }
      }
    }
    
    return select_desku_arr;
  };

  const go_change_todo_state_by_ajax = (inData: any) => {
    let opt_obj: any = {
      "todo_info": null,
      "is_success": "",
      ...inData,
    };
    if (opt_obj.todo_info == null || strFunc.is_empty(opt_obj.todo_info["a_seq"])) {
      alert("내용 없음.");
      return false;
    }

    let confirm_msg = opt_obj.todo_info["a_title"] + "을 완료처리 하시겠습니까?";
    if (opt_obj.is_success != "1") {
      confirm_msg = opt_obj.todo_info["a_title"] + "을 완료취소 하시겠습니까?";
    }
    if (!confirm(confirm_msg)) {
      return false;
    }

    let change_todo_state_row: any = {
      a_ymd: opt_obj.todo_info["a_ymd"],
      a_seq: opt_obj.todo_info["a_seq"],
    };

    let a_is_success = opt_obj.is_success;
    if (a_is_success == "1") {
      change_todo_state_row["a_is_success"] = a_is_success;
      change_todo_state_row["a_state"] = "complete";
      change_todo_state_row["a_end_date"] = DateFunc.get_date_format(new Date(), "Y-m-d h:i:s");
    } else {
      change_todo_state_row["a_is_success"] = "";
      change_todo_state_row["a_state"] = "ready";
      change_todo_state_row["a_amount_num"] = "0";
    }
    let form_json_data = {
      data_arr: [change_todo_state_row],
      is_update: "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          get_student_arr_by_ajax({});
        } else {

        }
      });
  };

  const update_io_of_desk_use_arr = (inData: any) => {
    let opt_obj = {
      desk_use_arr: [],
      detail: "update",//delete
      ...inData
    };

    if (data_io_ref.current && opt_obj.desk_use_arr) {
      data_io_ref.current.send({
        sort: "desk_use_arr",
        detail: opt_obj.detail,
        desk_use_arr: opt_obj.desk_use_arr,
        select_date: listOpt.s_select_date,
      });
    }
  };

  const open_find_stu_popup = (inData: any) => {
    let opt_obj: any = {
      "desk_info": null,
      "now_ymdhis": "",
      "now_lecture_data": null,
      ...inData,
    };

    //강의식 과목얻기
    let tmp_subject_name = "";
    for (let i = 0; i < infoArr.length; i++) {
      let tmp_room_info = infoArr[i];
      if (opt_obj["desk_info"] && tmp_room_info["a_seq"] == opt_obj["desk_info"]["a_room_seq"]) {
        if (tmp_room_info["a_subject"]) {
          tmp_subject_name = tmp_room_info["a_subject"];
          break;
        }
      }
    }

    setPopupData({
      ...popupData,
      "desk_info": opt_obj["desk_info"],
      "now_ymdhis": opt_obj["now_ymdhis"],
      "now_lecture_data": opt_obj["now_lecture_data"],
      "subject_name": tmp_subject_name,
      "isOpen": true,
      "title": "학생찾기",
      "sort": "find_stu",
      width: "800px",
    });
  };

  const open_view_desk_popup = (inData: any) => {
    let opt_obj = {
      room_info: null,
      desk_info: null,
      desku_info: null,
      now_ymdhis: "",
      now_lecture_data: null,
      ...inData
    };
    setPopupData({
      ...popupData,
      "room_info": opt_obj["room_info"],
      "desk_info": opt_obj["desk_info"],
      "desku_info": opt_obj["desku_info"],
      "now_ymdhis": opt_obj["now_ymdhis"],
      "now_lecture_data": opt_obj["now_lecture_data"],
      "isOpen": true,
      "title": "책상보기",
      "sort": "view_desk",
      width: "800px",
      has_header: true,
    });
  };

  const open_view_room_popup = (inData: any) => {
    let opt_obj: any = {
      room_seq: "",
      ...inData,
    };

    setPopupData({
      ...popupData,
      room_seq: opt_obj["room_seq"],
      "isOpen": true,
      "title": "좌석설정",
      "sort": "view_room",
      width: "100%",
      has_header: true,
    });
  };

  const open_select_stu_alloc_desk_popup = (inData: any) => {
    let opt_obj: any = {
      "desk_info": null,
      "now_ymdhis": "",
      "now_lecture_data": null,
      ...inData,
    };

    if (select_stu_data.is_select == false || select_stu_data.stu_info == null) {
      alert("학생선택이 필요합니다.");
      return false;
    }

    //강의식 과목얻기
    let tmp_subject_name = "";
    for (let i = 0; i < infoArr.length; i++) {
      let tmp_room_info = infoArr[i];
      if (opt_obj["desk_info"] && tmp_room_info["a_seq"] == opt_obj["desk_info"]["a_room_seq"]) {
        if (tmp_room_info["a_subject"]) {
          tmp_subject_name = tmp_room_info["a_subject"];
          break;
        }
      }
    }
    if (!strFunc.is_empty(select_stu_data.select_subject)) {
      tmp_subject_name = select_stu_data.select_subject;
    }

    setPopupData({
      ...popupData,
      stu_info: select_stu_data.stu_info,
      "desk_info": opt_obj["desk_info"],
      "now_ymdhis": opt_obj["now_ymdhis"],
      "now_lecture_data": opt_obj["now_lecture_data"],
      "subject_name": tmp_subject_name,
      "isOpen": true,
      "title": "학생찾기",
      "sort": "select_stu_alloc",
      width: "800px",
      has_header: true,
    });
  };

  const callBackDataFindStu = (inData: any) => {
    let opt_obj = {
      info_arr: [],
      "desk_info": null,
      "now_ymdhis": "",
      "select_time": {},
      ...inData,
    };
    let default_select_time = {
      "start_h": 0,
      "start_m": 0,
      "end_date": "0000-00-00",
      "end_h": 0,
      "end_m": 0,
      "subject": "",
      "is_target_time": "",
    };
    opt_obj["select_time"] = { ...default_select_time, ...opt_obj["select_time"] };
    if (opt_obj["select_time"]["is_target_time"] == "") {
      //opt_obj["select_time"]["end_date"] = DateFunc.get_date_format(DateFunc.get_change_date(new Date(opt_obj["now_ymdhis"]), 'day', +1), "Y-m-d");
    }

    if (opt_obj["info_arr"].length == 0) {
      alert("학생 선택이 필요합니다.");
      return false;
    }
    if (opt_obj["desk_info"] == null) {
      alert("책상정보가 없습니다.");
      return false;
    }
    // if (!confirm("등록 하시겠습니까?")) {
    //   return false;
    // }
    let u_info = opt_obj["info_arr"][0];
    let tmp_start_date_json = DateFunc.get_date_json(new Date(opt_obj["now_ymdhis"]));
    let tmp_end_hi = strFunc.HourMinuteToTime(opt_obj["select_time"]["end_h"], opt_obj["select_time"]["end_m"]);
    let tmp_end_date_json = DateFunc.get_date_json(new Date(opt_obj["select_time"]["end_date"] + " " + tmp_end_hi + ":" + tmp_start_date_json.s));
    let target_time_sec = tmp_end_date_json.date_obj.getTime() - tmp_start_date_json.date_obj.getTime();
    if (target_time_sec > 0) {
      target_time_sec = target_time_sec / 1000;
    } else {
      target_time_sec = 0;
    }

    let desk_u_row = {
      "a_ymd": DateFunc.get_date_format(new Date(opt_obj["now_ymdhis"]), "Ymd"),
      "a_seq": "",
      "a_room_seq": opt_obj["desk_info"]["a_room_seq"],
      "a_x": opt_obj["desk_info"]["a_x"],
      "a_y": opt_obj["desk_info"]["a_y"],
      "a_name": opt_obj["desk_info"]["a_name"],
      "a_subject": opt_obj["select_time"]["subject"],
      "a_date": DateFunc.get_date_format(new Date(opt_obj["now_ymdhis"]), "Y-m-d"),
      "a_end_date": opt_obj["select_time"]["end_date"],
      "a_user_seq": u_info["a_seq"],
      "a_user_name": u_info["a_user_name"],
      "a_user_grade": u_info["a_user_grade"],
      "a_start_h": opt_obj["select_time"]["start_h"],
      "a_start_m": opt_obj["select_time"]["start_m"],
      "a_end_h": opt_obj["select_time"]["end_h"],
      "a_end_m": opt_obj["select_time"]["end_m"],
      "a_target_time_sec": target_time_sec,
      "a_is_target_time": opt_obj["select_time"]["is_target_time"],
      "desk_is_finish": "",
      "a_writer_seq": user.user_seq,
      "a_writer": user.user_name,
    };

    let is_after_write_attend = "";
    if (is_add_attend_by_desk) {
      //is_after_write_attend="1";
    }
    let desku_w_form_data = {
      "data_arr": [desk_u_row],
      "is_default_val": "1",
      "is_after_write_attend": is_after_write_attend,
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/desku/add_arr', desku_w_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
          get_student_arr_by_ajax({});
          if (select_stu_data.is_select) {
            set_select_stu_data({
              is_select: false,
              stu_info: null,
            });
          }
          myProps.on_alloc_student({});
          update_io_of_desk_use_arr({
            desk_use_arr: response.data["data"],
            detail: "update",
          });
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const show_detail_view = (inData: any) => {
    let opt_obj = {
      stu_info: null,
      ...inData,
    };

    setPopupData({
      ...popupData,
      "isOpen": true,
      "title": "원생관리",
      "sort": "stu_view",
      write_page_data: {
        is_show: true,
        is_update: true,
        is_view_mode: true,
        is_view_basic: false,
        select_idx: 0,
        info_arr: [opt_obj.stu_info],
        default_write_info: {},
      },
      width: "98%",
      height: "99%",
      has_header: false,
    });
  };

  const openTodoDaySort = (inData: any) => {
    let opt_obj = {
      select_stu_name: "",
      select_stu_seq: "",
      select_date: listOpt.s_select_date,
      subject_name: "",
      ...inData
    };
    setPopupData({
      ...popupData,
      isOpen: true,
      has_header: true,
      sort: "todo_day_sort",
      title: "",
      width: "98%",
      height: "99%",
      ...opt_obj
    });
  };

  const openTodoWriteOnePopup = (inData: any) => {
    let opt_obj = {
      select_date: "",
      select_stu_name: "",
      select_stu_seq: "",
      todo_info: {},
      todo_sort: "study",
      isUpdate: true,
      ...inData
    };
    if (opt_obj["isUpdate"]) {
      if (strFunc.is_empty(opt_obj["todo_info"]["a_seq"])) {
        alert("내용 없음.");
        return false;
      }
    }
    setPopupData({
      ...popupData,
      isOpen: true,
      has_header: true,
      sort: "todo_write_one",
      select_stu_name: opt_obj["select_stu_name"],
      select_stu_seq: opt_obj["select_stu_seq"],
      select_date: opt_obj["select_date"],
      todo_sort: opt_obj["todo_sort"],
      todo_info: opt_obj["todo_info"],
      isUpdate: opt_obj["isUpdate"],
      title: "맞춤플랜",
      ...opt_obj
    });
  };

  const openTodoDailyCWritePopup = (inData: any) => {
    let opt_obj = {
      select_date: listOpt.s_select_date,
      check_row_val_arr: select_desku_seq_arr,
      todo_dailyc_sort: "complete",
      now_ymdhis: now_ymdhis,
      ...inData
    };
    let subject_name = "";
    let select_subejct_name_arr: any = [];
    let select_stu_seq_arr: any = [];
    let select_desku_arr = get_desku_arr_by_select_desku_seq_arr(opt_obj);

    for (let i = 0; i < select_desku_arr.length; i++) {
      let tmp_desku_info = select_desku_arr[i];
      if (strFunc.str_in_array(tmp_desku_info["a_user_seq"], select_stu_seq_arr) == -1) {
        select_stu_seq_arr.push(tmp_desku_info["a_user_seq"]);
      }
      if (!strFunc.is_empty(tmp_desku_info["a_subject"])) {
        if (strFunc.str_in_array(tmp_desku_info["a_subject"], select_subejct_name_arr) == -1) {
          select_subejct_name_arr.push(tmp_desku_info["a_subject"]);
        }
      }
    }

    if (opt_obj.check_row_val_arr.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }
    if (select_subejct_name_arr.length == 0) {
      alert("과목이 없습니다.");
      return false;
    }
    if (select_subejct_name_arr.length != 1) {
      alert("과목은 한개만 선택해주세요.");
      return false;
    }
    if (select_stu_seq_arr.length == 0) {
      alert("선택 학생이 없습니다.");
      return false;
    }
    subject_name = select_subejct_name_arr[0];

    setPopupData({
      ...popupData,
      isOpen: true,
      has_header: true,
      sort: "todo_dailyc_write",
      select_date: opt_obj["select_date"],
      subject_name: subject_name,
      select_stu_seq_arr: select_stu_seq_arr,
      todo_dailyc_sort: opt_obj.todo_dailyc_sort,
      check_row_val_arr: opt_obj.check_row_val_arr,
      now_ymdhis: opt_obj.now_ymdhis,
      title: "완료처리",
      width: "500px",
      ...opt_obj
    });
    set_select_desku_seq_arr([]);
  };

  const go_todo_dailyc_write = (inData: any) => {
    let opt_obj = {
      select_date: listOpt.s_select_date,
      check_row_val_arr: select_desku_seq_arr,
      todo_dailyc_sort: "complete",
      a_memo: "",
      ...inData
    };

    let subject_name = "";
    let select_subejct_name_arr: any = [];
    let select_stu_seq_arr: any = [];
    let select_desku_arr = get_desku_arr_by_select_desku_seq_arr(opt_obj);

    for (let i = 0; i < select_desku_arr.length; i++) {
      let tmp_desku_info = select_desku_arr[i];
      if (strFunc.str_in_array(tmp_desku_info["a_user_seq"], select_stu_seq_arr) == -1) {
        select_stu_seq_arr.push(tmp_desku_info["a_user_seq"]);
      }
      if (!strFunc.is_empty(tmp_desku_info["a_subject"])) {
        if (strFunc.str_in_array(tmp_desku_info["a_subject"], select_subejct_name_arr) == -1) {
          select_subejct_name_arr.push(tmp_desku_info["a_subject"]);
        }
      }
    }

    let stu_info_arr: any = [];
    for (let i = 0; i < student_info_arr.length; i++) {
      let tmp_stu_info = student_info_arr[i];
      if (strFunc.str_in_array(tmp_stu_info["a_seq"], select_stu_seq_arr) != -1) {
        stu_info_arr.push(tmp_stu_info);
      }
    }

    if (strFunc.is_empty(opt_obj.select_date)) {
      alert("날짜를 선택하세요.");
      return false;
    }
    if (select_subejct_name_arr.length >= 2) {
      alert("과목은 한개만 선택해주세요.");
      return false;
    }
    subject_name = select_subejct_name_arr[0];
    if (strFunc.is_empty(subject_name)) {
      alert("과목을 선택하세요.");
      return false;
    }
    if (strFunc.is_empty(opt_obj.todo_dailyc_sort)) {
      alert("구분을 선택하세요.");
      return false;
    }
    if (stu_info_arr.length == 0) {
      alert("학생을 선택하세요.");
      return false;
    }
    if (!confirm("완료 하시겠습니까?")) {
      return false;
    }

    let todo_dailyc_data = {
      a_date: opt_obj.select_date,
      a_subject: subject_name,
      a_stu_seq: "",
      a_sort: opt_obj.todo_dailyc_sort,
      a_memo: opt_obj.a_memo,
      a_writer_seq: user.user_seq,
      a_writer: user.user_name,
    };

    let write_todo_dailyc_arr: any = [];
    for (let i = 0; i < stu_info_arr.length; i++) {
      let stu_info = stu_info_arr[i];
      let stu_seq = stu_info["a_seq"];
      let stu_name = stu_info["user_name"];
      let todo_dailyc_data_obj = {
        ...todo_dailyc_data,
        a_stu_seq: stu_seq,
        a_stu_name: stu_name,
        a_writer_seq: user.user_seq,
        a_writer: user.user_name,
      };
      write_todo_dailyc_arr.push(todo_dailyc_data_obj);
    }
    let form_json_data = {
      "data_arr": write_todo_dailyc_arr,
      "is_auto_add_star": "1",
      "is_default_val": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/plan/todo/todo_dailyc/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          set_loading_data({
            is_display: true,
            text: "완료 되었습니다.",
          });
          setTimeout(() => {
            set_loading_data({
              ...loading_data,
              is_display: false,
            });
          }, 600);
          list({});
          get_student_arr_by_ajax({});
          go_finish_desk_use({
            check_row_val_arr: opt_obj.check_row_val_arr,
            is_confirm_msg: false,
          });
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_finish_desk_use = (inData: any) => {
    let opt_obj = {
      now_ymdhis: now_ymdhis,
      check_row_val_arr: select_desku_seq_arr,
      is_confirm_msg: true,
      ...inData
    };
    let select_desku_arr = get_desku_arr_by_select_desku_seq_arr(opt_obj);
    let finish_desku_arr: any = [];
    for (let i = 0; i < select_desku_arr.length; i++) {
      let tmp_desku_info = select_desku_arr[i];
      if (tmp_desku_info["a_is_finish"] == "1") {
        alert("이미 사용종료된 내역입니다.");
        return false;
      }
      finish_desku_arr.push(tmp_desku_info);
    }

    if (finish_desku_arr.length == 0) {
      alert("선택이 없습니다.");
      return false;
    }

    let change_use_data_row_arr: any = [];
    for (let i = 0; i < finish_desku_arr.length; i++) {
      let tmp_desku_info = finish_desku_arr[i];
      let change_use_data_row: any = {
        a_ymd: tmp_desku_info["a_ymd"],
        a_seq: tmp_desku_info["a_seq"],
      };
      let tmp_end_hi = strFunc.HourMinuteToTime(tmp_desku_info["a_start_h"], tmp_desku_info["a_start_m"]);
      let tmp_start_date_json = DateFunc.get_date_json(new Date(tmp_desku_info["a_date"] + " " + tmp_end_hi + ":00"));
      let now_date_json = DateFunc.get_date_json(new Date(opt_obj["now_ymdhis"]));
      change_use_data_row["a_end_date"] = DateFunc.get_date_format(now_date_json.date_obj, "Y-m-d");
      change_use_data_row["a_end_h"] = now_date_json.h;
      change_use_data_row["a_end_m"] = now_date_json.i;
      let target_time_sec = now_date_json.date_obj.getTime() - tmp_start_date_json.date_obj.getTime();
      if (target_time_sec > 0) {
        target_time_sec = target_time_sec / 1000;
      } else {
        target_time_sec = 0;
      }
      change_use_data_row["a_target_time_sec"] = target_time_sec;
      change_use_data_row["a_is_finish"] = "1";
      change_use_data_row_arr.push(change_use_data_row);
    }

    if (opt_obj.is_confirm_msg) {
      if (!confirm("좌석을 사용종료 하시겠습니까?")) {
        return false;
      }
    }

    let form_json_data = {
      "data_arr": change_use_data_row_arr,
      "is_update": "1"
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/desku/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.is_confirm_msg) {
            set_loading_data({
              is_display: true,
              text: "적용 되었습니다.",
            });
            setTimeout(() => {
              set_loading_data({
                ...loading_data,
                is_display: false,
              });
            }, 600);
          }
          list({});
          get_student_arr_by_ajax({});
          set_select_desku_seq_arr([]);
          update_io_of_desk_use_arr({
            desk_use_arr: response.data["data"],
            detail: "update",
          });
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const go_move_desku_info_by_ajax = (inData: any) => {
    let opt_obj = {
      "desku_info": null,
      "target_desk_info": null,
      "room_info": null,
      ...inData,
    };
    let target_desk_info = opt_obj.target_desk_info;
    let change_desku_info: any = {
      ...opt_obj.desku_info,
      a_room_seq: target_desk_info["a_room_seq"],
      a_x: target_desk_info["a_x"],
      a_y: target_desk_info["a_y"],
      a_name: target_desk_info["a_name"],
      a_subject: opt_obj.room_info["a_subject"],
    };
    let form_json_data = {
      "data_arr": [change_desku_info],
      "is_update": "1"
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/desku/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.is_confirm_msg) {
            set_loading_data({
              is_display: true,
              text: "적용 되었습니다.",
            });
            setTimeout(() => {
              set_loading_data({
                ...loading_data,
                is_display: false,
              });
            }, 600);
          }
          list({});
          get_student_arr_by_ajax({});
          set_select_desku_seq_arr([]);
          update_io_of_desk_use_arr({
            desk_use_arr: response.data["data"],
            detail: "update",
          });
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  return (
    <div ref={room_list_wrap_ref}>
      <div>
        <SearchArea
          student_info_arr={student_info_arr}
          list={list}
          get_student_arr_by_ajax={get_student_arr_by_ajax}
          listOpt={listOpt}
          search_room_list={search_room_list}
          now_ymdhis={now_ymdhis}
          set_now_ymdhis={set_now_ymdhis}
          is_now_time={is_now_time}
          set_is_now_time={set_is_now_time}
          is_show_only_now_lecture={is_show_only_now_lecture}
          set_is_show_only_now_lecture={set_is_show_only_now_lecture}
          is_show_msg={is_show_msg}
          set_is_show_msg={set_is_show_msg}
          set_room_msg_arr={set_room_msg_arr}
          is_show_stu_select_list={is_show_stu_select_list}
          set_is_show_stu_select_list={set_is_show_stu_select_list}
          is_stu_filter_lecture={is_stu_filter_lecture}
          set_is_stu_filter_lecture={set_is_stu_filter_lecture}
          select_stu_filter={select_stu_filter}
          set_select_stu_filter={set_select_stu_filter}
          is_stu_filter_use_desk={is_stu_filter_use_desk}
          set_is_stu_filter_use_desk={set_is_stu_filter_use_desk}
          select_stu_data={select_stu_data}
          set_select_stu_data={set_select_stu_data}
          is_add_attend_by_desk={is_add_attend_by_desk}
          set_is_add_attend_by_desk={set_is_add_attend_by_desk}
          is_able_card_view={is_able_card_view}
          cardview_sort={cardview_sort}
          set_cardview_sort={set_cardview_sort}
          openTodoDailyCWritePopup={openTodoDailyCWritePopup}
          go_finish_desk_use={go_finish_desk_use}
          is_show_history_btn={myProps.is_show_history_btn}
        ></SearchArea>
        {myProps.is_show_search_room &&
          <SearchRoomArea list={list} s_room_seq={listOpt.s_room_seq} search_room_list={search_room_list}></SearchRoomArea>
        }

        <div style={{ position: "relative" }}>
          <span style={{ position: "absolute", right: "10px", top: "-20px" }}>
            {myProps.is_show_history_btn &&
              <button className="btn btn-dark" onClick={() => { navigate("/comp/edu/desk/use_list"); }} >좌석사용이력</button>
            }
          </span>
        </div>
        {is_able_card_view == false &&
          <RoomListArea ref={RoomListAreaRef}
            room_info_arr={infoArr}
            now_ymdhis={now_ymdhis}
            pre_date_str={pre_date_str}
            open_find_stu_popup={open_find_stu_popup}
            open_view_desk_popup={open_view_desk_popup}
            open_select_stu_alloc_desk_popup={open_select_stu_alloc_desk_popup}
            is_detal_popup={myProps.is_detal_popup}
            is_show_only_now_lecture={is_show_only_now_lecture}
            is_show_msg={is_show_msg}
            is_show_stu_select_list={is_show_stu_select_list}
            is_stu_filter_lecture={is_stu_filter_lecture}
            is_stu_filter_use_desk={is_stu_filter_use_desk}
            select_stu_filter={select_stu_filter}
            set_select_stu_filter={set_select_stu_filter}
            room_msg_arr={room_msg_arr}
            student_info_arr={student_info_arr}
            select_stu_data={select_stu_data}
            set_select_stu_data={set_select_stu_data}
            dragged_desku_info={dragged_desku_info}
            set_dragged_desku_info={set_dragged_desku_info}
            go_move_desku_info_by_ajax={go_move_desku_info_by_ajax}
          ></RoomListArea>
        }
        {is_able_card_view &&
          <CardRoomListArea
            room_info_arr={infoArr}
            student_info_arr={student_info_arr}
            set_student_info_arr={set_student_info_arr}
            now_ymdhis={now_ymdhis}
            pre_date_str={pre_date_str}
            cardview_sort={cardview_sort}
            select_desku_seq_arr={select_desku_seq_arr}
            set_select_desku_seq_arr={set_select_desku_seq_arr}
            open_view_room_popup={open_view_room_popup}
            show_detail_view={show_detail_view}
            open_view_desk_popup={open_view_desk_popup}
            openTodoDaySort={openTodoDaySort}
            openTodoWriteOnePopup={openTodoWriteOnePopup}
            go_change_todo_state_by_ajax={go_change_todo_state_by_ajax}
            openTodoDailyCWritePopup={openTodoDailyCWritePopup}
            go_todo_dailyc_write={go_todo_dailyc_write}
          ></CardRoomListArea>
        }
        {myProps.is_show_paging &&
          <Paging now_page={listOpt.now_page}
            num_per_page={listOpt.num_per_page}
            total_rec={countInfo.tot}
            onChangePage={(now_page: number) => { list({ now_page: now_page }); }}></Paging>
        }
      </div>
      <LoadingComponent is_display={loading_data.is_display} text={loading_data.text}></LoadingComponent>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} title_bar_style={{ borderBottom: 0 }}
          content_div_style={{ padding: "10px 0px" }} y={"0"} has_header={popupData.has_header}>
          {popupData.sort === "find_stu" &&
            <FindStudentPopup
              room_info={popupData.room_info}
              desk_info={popupData.desk_info}
              now_ymdhis={popupData.now_ymdhis}
              now_lecture_data={popupData.now_lecture_data}
              subject={popupData.subject_name}
              callBackData={callBackDataFindStu}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></FindStudentPopup>
          }
          {popupData.sort === "select_stu_alloc" &&
            <SelectStuAllowDeskPopup
              stu_info={popupData.stu_info}
              room_info={popupData.room_info}
              desk_info={popupData.desk_info}
              now_ymdhis={popupData.now_ymdhis}
              now_lecture_data={popupData.now_lecture_data}
              subject={popupData.subject_name}
              callBackData={callBackDataFindStu}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></SelectStuAllowDeskPopup>
          }
          {popupData.sort == "view_desk" &&
            <ViewDeskPopup
              room_info={popupData.room_info}
              desk_info={popupData.desk_info}
              desku_info={popupData.desku_info}
              now_ymdhis={popupData.now_ymdhis}
              now_lecture_data={popupData.now_lecture_data}
              callBackData={() => { list({ "now_page": "1" }) }}
              callback_update={(inData: any) => {
                update_io_of_desk_use_arr({
                  desk_use_arr: inData["desk_use_arr"],
                  detail: "update",
                });
              }}
              callback_delete={(inData: any) => {
                update_io_of_desk_use_arr({
                  desk_use_arr: inData["desk_use_arr"],
                  detail: "delete",
                });
              }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewDeskPopup>
          }
          {popupData.sort == "view_room" &&
            <ViewRoomPopup
              room_seq={popupData.room_seq}
              is_window_popup={false}
              is_close_at_alloc_desk={true}
              callBackRfresh={() => { list({ "now_page": "1" }) }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewRoomPopup>
          }
          {popupData.sort === "stu_view" &&
            <ViewStuLayerPopup
              write_page_data={popupData.write_page_data}
              callback={() => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewStuLayerPopup>
          }
          {popupData.sort == "todo_day_sort" &&
            <ViewTodoDaySortPopup
              list_opt={{
                "s_stu_user_name": popupData.select_stu_name,
                "s_stu_user_seq": popupData.select_stu_seq,
                "s_start_date": popupData.select_date,
                "s_end_date": popupData.select_date,
                "s_subject": popupData.subject_name,
              }}
              list={() => {
                list({});
                get_student_arr_by_ajax({});
              }}
              openTodoWriteOnePopup={openTodoWriteOnePopup}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></ViewTodoDaySortPopup>
          }
          {popupData.sort == "todo_write_one" &&
            <WriteTodoPopup
              stu_seq={popupData.select_stu_seq}
              stu_name={popupData.select_stu_name}
              select_date={popupData.select_date}
              rowData={popupData.todo_info}
              todo_sort={popupData.todo_sort}
              isUpdate={popupData.isUpdate}
              callback={(inData: any) => {
                list({});
                get_student_arr_by_ajax({});
              }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></WriteTodoPopup>
          }
          {popupData.sort === "todo_dailyc_write" &&
            <WriteTodoDailyCByStuPopup
              select_date={popupData.select_date}
              subject_name={popupData.subject_name}
              stu_seq_arr={popupData.select_stu_seq_arr}
              sort={popupData.todo_dailyc_sort}
              callback_complete={(inData: any) => {
                if (inData.todo_dailyc_arr && inData.todo_dailyc_arr.length > 0 && data_io_ref.current) {
                  data_io_ref.current.send({
                    sort: "todo_dailyc_arr",
                    detail: "update",
                    todo_dailyc_arr: inData.todo_dailyc_arr,
                    select_date: popupData.select_date,
                  });
                }
                if (inData.end_desk_use_arr && inData.end_desk_use_arr.length > 0 && data_io_ref.current) {
                  data_io_ref.current.send({
                    sort: "desk_use_arr",
                    detail: "update",
                    desk_use_arr: inData.end_desk_use_arr,
                    select_date: popupData.select_date,
                  });
                }
              }}
              callback_delete_todoc={(inData: any) => {
                if (inData.todo_dailyc_arr && inData.todo_dailyc_arr.length > 0 && data_io_ref.current) {
                  data_io_ref.current.send({
                    sort: "todo_dailyc_arr",
                    detail: "delete",
                    todo_dailyc_arr: inData.todo_dailyc_arr,
                    select_date: popupData.select_date,
                  });
                }
              }}
              callback_refresh={() => { list({}); get_student_arr_by_ajax({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></WriteTodoDailyCByStuPopup>
          }
        </LayerPopup>
      }
      <DataIo
        data_io_ref={data_io_ref}
        roomInfoArrRef={roomInfoArrRef}
        setRoomInfoArr={setInfoArr}
        student_info_arr_ref={student_info_arr_ref}
        set_student_info_arr={set_student_info_arr}
        listOptRef={listOptRef}
      ></DataIo>
    </div>
  );
}

export default RoomListWrap;